import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ARCHIVE_CATEGORIES } from "@/lib/archiveCatalog";

export const ArchiveFilters = ({ query, setQuery, category, setCategory, sort, setSort }) => (
  <div className="archive-filters">
    <div className="archive-search"><Search size={16} aria-hidden="true" /><Input aria-label="Search archive by name or frequency" placeholder="SEARCH ARCHIVE / Hz" value={query} onChange={event => setQuery(event.target.value)} data-testid="archive-search" /></div>
    <Select value={category} onValueChange={setCategory}>
      <SelectTrigger aria-label="Archive category" data-testid="archive-category"><SelectValue /></SelectTrigger>
      <SelectContent className="archive-dropdown" data-testid="archive-category-menu">
        {ARCHIVE_CATEGORIES.map(([value, label]) => <SelectItem key={value} value={value} data-testid={`archive-category-${value}`}>{label}</SelectItem>)}
      </SelectContent>
    </Select>
    <Select value={sort} onValueChange={setSort}>
      <SelectTrigger aria-label="Sort archive" data-testid="archive-sort"><SelectValue /></SelectTrigger>
      <SelectContent className="archive-dropdown" data-testid="archive-sort-menu">
        <SelectItem value="name" data-testid="archive-sort-name">Name A–Z</SelectItem>
        <SelectItem value="frequency" data-testid="archive-sort-frequency">Frequency ↑</SelectItem>
      </SelectContent>
    </Select>
  </div>
);